/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSouscriptionCustomerGranteesMutation from '../graphql/mutations/SaveSouscriptionCustomerGranteesMutation.js';

export const useSaveSouscriptionCustomerGranteesMutation = () => {
  return useCommitMutation(SaveSouscriptionCustomerGranteesMutation, {
    dataProp: 'saveSouscriptionCustomerGrantees_M_souscription_customer_grantees'
  });
};

export default useSaveSouscriptionCustomerGranteesMutation;
